export const isOperator = (user) =>
  !user?.is_guest && ["dj", "venue"].includes(user?.role);
export function homeFor(user) {
  if (!user) return "/signin";
  if (user.is_guest)
    return `/dashboard?session=${encodeURIComponent(user.guest_session_id)}`;
  if (user.role === "admin" || user.is_admin) return "/admin/dashboard";
  return isOperator(user) ? "/dj" : "/discover";
}
export function safeAudienceReturn(path) {
  return typeof path === "string" &&
    /^\/(?:discover(?:\?|$)|dashboard(?:\?|$)|sessions$|session\/[^/]+\/(?:request|shoutout|my-requests)(?:\?|$)|profile(?:\/[^/]+)?$|history$|settings$|feed$|leaderboards$)/.test(
      path,
    ) &&
    !path.includes("\\")
    ? path
    : "/discover";
}
